import React from "react";
import Footer from "../layouts/Footer";
import Navbar from "../Navbar";
import "./AboutUs.css"; 

const AboutUs = () => {
  return (
    <>
      <Navbar />
      <div className="container">
        <div className="about-us-section my-4">
          <h2>ABOUT US</h2>
          <p>
            <strong>“Natraj”</strong> is a well-known brand of Haryana Traders
            Pvt. Ltd., which markets paper and plastic stationery products
            across India and most of the Subcontinent.
          </p>
          <p>
            Incorporated in 1974 as a partnership firm between two brothers,{" "}
            <strong>“Natraj Paper Corporation”</strong> has grown into a
            reliable and trusted enterprise, manufacturing high-quality paper
            products designed to meet the needs of both offices and schools.
          </p>
          <p>
            Built on the principle of <strong>‘Fairness’</strong> in our
            dealings and transactions, we have earned the unwavering trust of
            our customers over the past five decades. In 2001, the firm was
            restructured into a sole proprietorship, streamlining operations and
            ensuring a more efficient workflow to serve our customers better.
          </p>
          <p>
            Our wide-ranging product portfolio offers comprehensive school and
            office stationery solutions for corporate houses, educational
            institutions, and individual customers. Our products are known for
            their durability, quality, and innovation, meeting the ever-changing
            demands of our clientele.
          </p>
          <p>
            In addition to our in-house production, we have formed strong
            alliances with several national and international stationery brands.
            This collaboration enables us to offer an optimized product
            portfolio that caters to both{" "}
            <strong>Direct-to-Consumer (D2C)</strong> and{" "}
            <strong>Business-to-Business (B2B)</strong> segments.
          </p>
          <p>
            With decades of experience and a commitment to excellence, “Natraj”
            has become a household name in stationery, synonymous with quality
            and trust. Our state-of-the-art manufacturing facilities and a
            dedicated team of professionals ensure that we consistently deliver
            products that exceed expectations.
          </p>
          <p>
            Today, we are proud to be a leader in the industry, not only
            supplying our products to distributors and dealers but also
            providing customized solutions for corporate gifting, branded
            merchandise, and exclusive stationery designs. Our aim is to create
            lasting relationships with our customers by providing value through
            innovation and superior quality.
          </p>
          <p>
            At “Natraj,” our mission is clear:{" "}
            <strong>
              To deliver excellence in every product, ensuring our customers
              receive great value through great products.
            </strong>
          </p>
        </div>
      </div>
      {/* <Footer/> */}
    </>
  );
};

export default AboutUs;
